import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lean-tree',
  templateUrl: './lean-tree.component.html',
  styleUrls: ['./lean-tree.component.css']
})
export class LeanTreeComponent implements OnInit {

  @Input() node               : any;
  @Input() labelFieldName     : string;
  @Input() labelFieldCode     : string;
  @Input() chieldrenFieldName : string;
  @Input() level              : number;

  @Output() onClick  = new EventEmitter<any>();  
  @Output() onDoubleClick  = new EventEmitter<any>();  

  expanded:boolean = false;
  
  constructor() { }

  ngOnInit() {
    this.levelPadding();
  }

  levelPadding(){
    let level = this.level;
    level++
    return ""+level*10+"px";
  }


click(child : any){
  this.onClick.emit(child);
}
doubleClick(child : any){
  this.onDoubleClick.emit(child);
}

clickCurrent(){
  this.onClick.emit(this.node);
}

doubleClickCurrent(){
  this.onDoubleClick.emit(this.node);
}

}

/*
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lean-tree',
  templateUrl: './lean-tree.component.html',
  styleUrls: ['./lean-tree.component.css']
})
export class LeanTreeComponent implements OnInit {

  @Input() node               : any;
  @Input() labelFieldName     : string;
  @Input() labelFieldCode     : string;
  @Input() chieldrenFieldName : string;
  @Input() level              : number;

  @Output() onSelect  = new EventEmitter<any>();  

  expanded:boolean = false;
  
  constructor() { }

  ngOnInit() {
    this.levelPadding();
  }

  levelPadding(){
    let level = this.level;
    level++
    return ""+level*10+"px";
  }


selectChild(child : any){
  this.onSelect.emit(child);
}

selectNode(){
  this.onSelect.emit(this.node);
}

}
*/